import { BaseUniDriver } from '@wix/wix-ui-test-utils/base-driver';

export type SidebarUniDriver = BaseUniDriver;
